<template>
  <div>
    <vue-goodshare-facebook :page_url="url" has_icon></vue-goodshare-facebook>
    <vue-goodshare-twitter :page_url="url" has_icon></vue-goodshare-twitter>
    <vue-goodshare-linked-in :page_url="url" has_icon></vue-goodshare-linked-in>
    <vue-goodshare-google-plus :page_url="url" has_icon></vue-goodshare-google-plus>
    <vue-goodshare-tumblr :page_url="url" has_icon></vue-goodshare-tumblr>
    <vue-goodshare-pinterest :page_url="url" has_icon></vue-goodshare-pinterest>
    <vue-goodshare-reddit :page_url="url" has_icon></vue-goodshare-reddit>
  </div>
</template>

<script>
// Import vue-goodshare single elements
import VueGoodshareFacebook from 'vue-goodshare/src/providers/Facebook';
import VueGoodshareTwitter from 'vue-goodshare/src/providers/Twitter';
import VueGoodshareLinkedIn from 'vue-goodshare/src/providers/LinkedIn';
import VueGoodshareGooglePlus from 'vue-goodshare/src/providers/GooglePlus';
import VueGoodshareTumblr from 'vue-goodshare/src/providers/Tumblr';
import VueGoodsharePinterest from 'vue-goodshare/src/providers/Pinterest';
import VueGoodshareReddit from 'vue-goodshare/src/providers/Reddit';

export default {
  data() {
    return {
    };
  },
  props: ['url'],
  components: {
    VueGoodshareFacebook,
    VueGoodshareTwitter,
    VueGoodshareLinkedIn,
    VueGoodshareGooglePlus,
    VueGoodshareTumblr,
    VueGoodsharePinterest,
    VueGoodshareReddit,

  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// Share.vue?684676a5